import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx'; // Import our main component
import './index.css';

// We assume a minimal CSS file for tailwind/global styles would be imported here in a real project,
// but for the single-file concept, we only need to bootstrap React.

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);